import { useContext, createContext as createReactContext } from "react";

export const AppLogOutContext = createReactContext<() => void>(() => undefined);
AppLogOutContext.displayName = "AppLogOutContext";

export const { Provider: AppLogOutProvider, Consumer: AppLogOutConsumer } =
  AppLogOutContext;

export function useLogOutContext() {
  return useContext(AppLogOutContext);
}
